<template>
  <p class="checkout-overlay-text"><slot /></p>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-title {
    & + .checkout-overlay-text {
      margin-top: 0;
    }
  }

  .checkout-overlay-text {
    color: $color-blue;
    line-height: 1.4em;
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-text'
  }
</script>
